import axios from "axios";
import ReactGA from "react-ga4";

export function createTokenManager() {
  let token; // Private variable to store the token

  function getToken() {
    return token; // Getter function
  }

  function setToken(newToken) {
    token = newToken; // Setter function
  }

  return { getToken, setToken }; // Return an object with the getter and setter functions
}

export const tokenManager = createTokenManager();

const axiosTokenInstance = axios.create({
  baseURL: process.env.REACT_APP_TYPETESTER_BACKEND_URL,
});

axiosTokenInstance.interceptors.request.use(
  async (config) => {
    config.headers.Authorization = `Bearer ${tokenManager.getToken()}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosTokenInstance.interceptors.response.use(
  async (response) => {
    return response;
  },
  (error) => {
    ReactGA.gtag('event', 'error', {
      action: 'error occured',
      label: error.message
  });
    return Promise.reject(error);
  }
);

export default axiosTokenInstance;
